"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = require("../component");

var _proptypes = require("../utils/proptypes");

var _numbers = require("../utils/numbers");

var _styles = require("../styles");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Carousel, _PureComponent);

  function Carousel(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      current: 0,
      direction: 'stop',
      pre: 0
    };
    _this.handleMouseIn = _this.handleMouseIn.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.moveTo = _this.moveTo.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.setNext(1);

    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.setNext = function setNext(next) {
    var _this2 = this;

    var interval = this.props.interval;

    if (interval > 0) {
      if (this.$timeout) clearTimeout(this.$timeout);
      this.$timeout = setTimeout(function () {
        _this2.moveTo(next);
      }, interval);
    }
  };

  _proto.moveTo = function moveTo(next) {
    var current = this.state.current;
    if (next === current) return;
    var direction = next > current ? 'forward' : 'backward';

    if (next >= this.count) {
      direction = 'forward';
      next = 0;
    }

    this.setState({
      pre: current,
      current: next,
      direction: direction
    });
    this.setNext(next + 1);
  };

  _proto.handleMouseIn = function handleMouseIn() {
    this.mouseInView = true;
  };

  _proto.handleMouseOut = function handleMouseOut() {
    this.mouseInView = false;
    this.setNext(this.state.current + 1);
  };

  _proto.renderItems = function renderItems() {
    var _this$state = this.state,
        current = _this$state.current,
        pre = _this$state.pre;
    return _react.Children.toArray(this.props.children).map(function (child, i) {
      return _react.default.createElement(_Item.default, {
        key: i,
        current: i === current,
        pre: i === pre && pre !== current
      }, child);
    });
  };

  _proto.renderCustomIndicator = function renderCustomIndicator() {
    var _this$props = this.props,
        indicatorType = _this$props.indicatorType,
        indicatorPosition = _this$props.indicatorPosition;
    var current = this.state.current;
    var className = (0, _styles.carouselClass)('indicator', "indicator-" + indicatorPosition);
    return _react.default.createElement("div", {
      className: className
    }, indicatorType(current, this.moveTo));
  };

  _proto.renderIndicator = function renderIndicator() {
    var _this3 = this;

    var _this$props2 = this.props,
        indicatorPosition = _this$props2.indicatorPosition,
        indicatorType = _this$props2.indicatorType;

    if (typeof indicatorType === 'function') {
      return this.renderCustomIndicator();
    }

    var current = this.state.current;
    var className = (0, _styles.carouselClass)('indicator', "indicator-" + indicatorPosition, "indicator-" + indicatorType);
    var inds = (0, _numbers.range)(this.count).map(function (i) {
      return _react.default.createElement("a", {
        key: i,
        href: "javascript:;",
        onClick: _this3.moveTo.bind(_this3, i),
        className: (0, _styles.carouselClass)(current === i && 'indicator-active')
      }, indicatorType === 'number' ? i + 1 : '');
    });
    return _react.default.createElement("div", {
      className: className
    }, inds);
  };

  _proto.render = function render() {
    this.count = _react.Children.toArray(this.props.children).length;
    var _this$props3 = this.props,
        animation = _this$props3.animation,
        style = _this$props3.style;
    var direction = this.state.direction;
    var className = (0, _classnames.default)((0, _styles.carouselClass)('_', animation, direction), this.props.className);
    return _react.default.createElement("div", {
      className: className,
      style: style
    }, this.renderItems(), this.renderIndicator());
  };

  return Carousel;
}(_component.PureComponent);

Carousel.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'size', 'type'), {
  animation: _propTypes.default.oneOf(['slide', 'slide-y', 'fade']),
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]),
  indicatorPosition: _propTypes.default.oneOf(['left', 'center', 'right']),
  indicatorType: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.oneOf(['number', 'circle', 'line'])]),
  interval: _propTypes.default.number
});
Carousel.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  animation: 'slide',
  indicatorPosition: 'center',
  indicatorType: 'circle',
  interval: 0
});
Carousel.displayName = 'ShineoutCarousel';
var _default = Carousel;
exports.default = _default;